import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStore } from "../../stores/store";
import useAuth from '../../hooks/useAuth';
import { observer } from "mobx-react-lite";
import useLogout from "../../hooks/useLogout";
import { axiosPrivate } from '../../api/axios';
import useSystemLogo from '../../hooks/useSystemLogo';
function TopHeader({ toggleSidebar }) {
  const { mainStore } = useStore();
  const { t, i18n } = useTranslation();
  const { auth } = useAuth();
  const logout = useLogout();
  const systemLogo = useSystemLogo();

  const signOut = async () => {
    await logout();

  };


  const closeMenu = () => {
    const menu = document.getElementById("topHeaderMenu");
    if (menu.classList.contains("show")) {
      menu.classList.remove("show");
    }
  };

  const setLanguage = async (lang) => {
    console.log('[LANG DEBUG] setLanguage called with:', lang);
    console.log('[LANG DEBUG] i18n.language BEFORE:', i18n.language);
    try {
      const resp = await axiosPrivate.get(`/Home/SetLanguage/${lang}`);
      console.log('[LANG DEBUG] SetLanguage API response status:', resp.status);
      console.log('[LANG DEBUG] SetLanguage response headers:', JSON.stringify(resp.headers));
    } catch (err) {
      console.error('[LANG DEBUG] SetLanguage API FAILED:', err);
    }
    i18n.changeLanguage(lang);
    console.log('[LANG DEBUG] i18n.language AFTER:', i18n.language);
    mainStore.setLang(lang);
  };


  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-2">

      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleSidebar}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <Link className="navbar-brand mx-auto" to="/Home">
          <img src={systemLogo} alt="Logo" style={{ height: '40px' }} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#topHeaderMenu"
          aria-controls="topHeaderMenu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="topHeaderMenu">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
    

            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="/#"
                id="dropdownProfile"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>
                  <i className="bi bi-person-circle me-2"></i>
                  {auth?.fullName}
                </span>
              </a>
              <ul
                className="dropdown-menu dropdown-menu-light dropdown-menu-end shadow" 
                style={{ fontSize: '0.9rem' }}
                aria-labelledby="dropdownProfile"
              >
                {}

                {auth?.lastSuccessfulLoginDate && (
                  <li>
                    <span className="dropdown-item-text text-muted" style={{ fontSize: "0.8rem" }}>
                      <i className="bi bi-clock-history me-2"></i>
                      {t("lastLogin")}: {(() => {
                        const date = new Date(auth.lastSuccessfulLoginDate);
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        const hours = String(date.getHours()).padStart(2, '0');
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        const seconds = String(date.getSeconds()).padStart(2, '0');
                        return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
                      })()}
                    </span>
                  </li>
                )}
                {auth?.lastSuccessfulLoginDate && (
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                )}

                {}
                {['lng1', 'lng2', 'lng3'].map((slot) => {
                  const lang = window.__UMS_THEME__?.languages?.[slot];
                  if (!lang) return null;
                  return (
                    <li key={slot}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setLanguage(slot);
                        }}
                        className={`dropdown-item ${i18n.language === slot ? "bg-light text-danger fw-semibold" : ""}`}
                      >
                        {lang.name}
                      </a>
                    </li>
                  );
                })}

                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li className="mb-1">
                  <Link to="#" onClick={signOut} className="dropdown-item text-danger">
                    <i className="bi bi-box-arrow-right me-2"></i>
                    {t("profileLogout")}
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default observer(TopHeader);